import BasicRouterView from "../../components/BasicRouterView.vue";

const gestaoDeRiscosRoutes = {
  path: "gdr",
  redirect: { name: "gestao-de-riscos" },
  meta: {
    label: "Gestão de Riscos",
    icon: "warning",
    permissioOnly: false,
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "gestao-de-riscos/listar",
      name: "gestao-de-riscos",
      meta: {
        label: "Gestão de Riscos",
        icon: "warning",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "gdr" */ "./views/GestaoDeRiscos.vue"),
    },
    {
      path: "gestao-de-riscos/relatorio",
      name: "gestao-de-riscos-relatorio",
      meta: {
        label: "Relatório de Riscos",
        icon: "assessment",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "gdr" */ "./views/RelatorioRiscos.vue"),
    },
    {
      path: "gestao-de-riscos/relatorio-vinculos",
      name: "gestao-de-riscos-relatorio-vinculos",
      meta: {
        label: "Relatório de Riscos Vinculados",
        icon: "assessment",
        permissioOnly: false,
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "gdr" */ "./views/RelatorioVinculos.vue"),
    },
  ],
};

export default gestaoDeRiscosRoutes;
